import { createContext } from 'react';

export const MobileAppContext = createContext();
